<template>
    <div class="mainCon">
      <div class="contbanner standbymain">
        <div class="mainDivWidth flexDiv stanmain">
          <div class="stanLeft wow fadeInLeft animated">
            <div class="scene-Header">
              <div class="flexDiv">
                <div class="stancont">
                  <p class="sceneTitle">渠道发券活动</p> 
                  <p class="backtxt">全国100+企业ETC拉新的选择</p>
                </div>
                <p class="explantxt">企业通过维纳宝平台（app或网页版）为指定用户发券</p>
                <div class="startban">
                    <p>推荐指数：</p>
                    <img src="static/img/activity/start.png" alt="">
                    <img src="static/img/activity/start.png" alt="">
                    <img src="static/img/activity/start.png" alt="">
                    <img src="static/img/activity/start.png" alt="">
                  </div>
              </div>
            </div>
          </div>
          <div class="stanRight wow fadeInRight animated">
            <img src="static/img/activity/buyCoupon/bannerpic.png" alt="">
          </div>
        </div>
      </div>
      <div class="conticon">
        <div class="mainDivWidth flexDiv conmains" >
          <div class="ditchList wow zoomIn animated" v-for="conlis in conticonList" @click="changeanchorId(conlis.id)">
            <img :src="conlis.pic" alt="">
            <p>{{conlis.title}}</p>
          </div>
        </div>
      </div>
      <section id="recommend">
        <div class="mainDivWidth">
          <h3 class="sectionTitle">推荐理由</h3>
          <div class="recommend flexDiv">
            <div v-for="rec in recomList"  class="recomlist">
              <img :src="rec.icons" alt="">
              <div class="recomtxt">
                <p>{{rec.title}}</p>
                <span>{{rec.cont}}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="contbg" id="contbg">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">活动数据</h3>
          <div class="flexDiv actDatamain">
            <div class="activedata" v-for="actl in activedatas">
              <p>{{actl.nums}}</p>
              <span>{{actl.explain}}</span>
            </div>
          </div>
        </div>
      </section>
      <section id="flowPath">
        <div class="mainDivWidth">
          <h3 class="sectionTitle">活动流程</h3>
          <div class="flexDiv flowpics">
            <p class="flowTitle bg01">企业流程</p>
            <div class="floecont picSize">
              <img src="static/img/activity/actChannelSend/flowpic/firm/firm01.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actChannelSend/flowpic/firm/firm02.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actChannelSend/flowpic/firm/firm03.png" alt="">
            </div>
          </div>
          <div class="flexDiv flowpics">
            <p class="flowTitle bg02">用户流程</p>
            <div class="floecont">
              <img src="static/img/activity/actChannelSend/flowpic/user/user01.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actChannelSend/flowpic/user/user02.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actChannelSend/flowpic/user/user03.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actChannelSend/flowpic/user/user04.png" alt="">
              <img class="direct" src="static/img/activity/dirsmall.png" alt="">
              <img src="static/img/activity/actChannelSend/flowpic/user/user05.png" alt="">
            </div>
          </div>
        </div>
      </section>
      <section id="actCase">
        <div class="casebg">
          <div class="mainDivWidth">
            <h3 class="sectionTitle whiteText">活动案例</h3>
            <div class="flexDiv casecont">
              <img class="wow rotateInDownRight animated" src="static/img/activity/actChannelSend/casepic/caseicon01.png" alt="">
              <img class="wow rotateInDownRight animated" src="static/img/activity/buyCoupon/casepic/case02.png" alt="">
              <img class="wow rotateInDownRight animated" src="static/img/activity/buyCoupon/casepic/case03.png" alt="">
            </div>
          </div>
        </div>
      </section>
      
      <section>
        <div class="mainDivWidth">
          <h3 class="sectionTitle">我们还可以做到</h3>
          <div class="flexDiv maskcont">
            <div class="maskban wow bounceIn animated" v-for="mas in maskList">
              <img :src="mas.pics" alt="">
              <p>{{mas.title}}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import { WOW } from "wowjs";
  export default {
    name: 'actChannelSend',
    data:function(){
      return {
        conticonList:[
          {
            id:"recommend",
            title:"推荐理由",
            pic:"static/img/activity/standby/icon-2/logo01.png"
          },
          {
            id:"contbg",
            title:"活动数据",
            pic:"static/img/activity/standby/icon-2/logo02.png"
          },
          {
            id:"flowPath",
            title:"活动流程",
            pic:"static/img/activity/standby/icon-2/logo03.png"
          },
          {
            id:"actCase",
            title:"活动案例",
            pic:"static/img/activity/standby/icon-2/logo04.png"
          },
        ],
        recomList: [
          {
            icons:"static/img/activity/exchange/icon-1/icon01.png",
            title:"发券时间灵活控制",
            cont:"支持现场发送即时到账，无需等待用户体验效果好"
          },
          {
            icons:"static/img/activity/standby/icon-1/actstan03.png",
            title:"自有账户更可控",
            cont:"自行发券，精准触达服务对象，用户信息保密"
          },
          {
            icons:"static/img/activity/actAdminSend/icon-1/case01.png",
            title:"批量操作更便捷",
            cont:"PC端批量发券，一键操作省心省力"
          },
          {
            icons:"static/img/activity/standby/icon-1/actstan03.png",
            title:"多人操作，额度共享",
            cont:"支持一个机构多个账号发券，额度可控，分类数据管理一目了然"
          },
          {
            icons:"static/img/activity/exchange/icon-1/icon05.png",
            title:"手握优惠促核销",
            cont:"用户可查看账户优惠，促进有效期内核销体验，提高交易增加留存"
          }
        ],
        activedatas:[
          {
            nums:"60个+", 
            explain:"活动数量"
          },
          {
            nums:"100万人次+", 
            explain:"参与人数"
          },
          {
            nums:"7800万元+", 
            explain:"优惠金额"
          },
          {
            nums:"31000万元+", 
            explain:"交易金额"
          }
        ],
        maskList:[
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic01.png",
            title:"加油券 油企电子券 话费券 油卡充值券 通用券等等",
          },
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic02.png",
            title:"仅限自有渠道（公众号/APP）核销—用户留存",
          }, 
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic03.png",
            title:"一个账户多张券选择性发放",
          },
          {
            pics:"static/img/activity/actAdminSend/maspic/maspic04.png",
            title:"指定品牌商户可享优惠—二次精准营销（如银行+油企合资）",
          }
        ]
      }
    },
    mounted() {
      var wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: false
      });
      wow.init();
    },
    methods: {
      changeanchorId(id) {
        $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
        this.backTop = true;
        return false; // 返回false可以避免在原链接后加上#
      },
    }
  }
  </script>
  <style scoped lang="scss">
    @import "../../assets/css/activityClass/actChan";
  </style>
  


// WEBPACK FOOTER //
// src/pages/activityTypePage/activity3-channelSend.vue